import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@finitless/shared/lib";
import { isEndpointEnabled } from "@finitless/shared/config";
import { buildQueryParams } from "../lib/globalUtils";

export const useExportUsers = () => {
  return useMutation({
    mutationFn: async ({
      userType = "customers",
      enabledFilter = "all",
      searchTerm = "",
    }) => {
      // Build where clause based on filters
      const whereClause = {
        conditions: [
          {
            attribute: "level",
            value:
              userType === "customers"
                ? [3]
                : userType === "business-owners"
                  ? [2]
                  : [0],
          },
        ],
        conector: "AND",
      };

      // Add enabled filter if not 'all'
      if (enabledFilter !== "all") {
        whereClause.conditions.push({
          attribute: "enabled",
          value: enabledFilter === "active",
        });
      }

      // Add search filter if provided
      if (searchTerm) {
        whereClause.conditions.push({
          attribute: "name",
          value: searchTerm,
        });
      }

      // Build query parameters
      const params = {
        mode: "dashboard",
        orderBy: "id",
        version: "v2",
        where: whereClause,
      };

      const queryString = buildQueryParams(params);
      const response = await apiClient.get(
        `/users_new.csv${queryString ? `?${queryString}` : ""}`,
      );

      return response;
    },
    enabled: isEndpointEnabled("dashboard", "users"),
  });
};

export default useExportUsers;
